module.exports = __webpack_public_path__ + "assets/img/c14.2195bbf0.png";